import { useEffect, useState } from "react";

const OfficeDates = ({ data }) => {
  const [columnOne, setColumnOne] = useState({});
  const [columnTwo, setColumnTwo] = useState({});
  const darkStatus = data.officeStatus?.toLowerCase()?.includes("dark");
  const ReOpen = data.officeStatus?.toLowerCase()?.includes("open");
  const prevStatus = data.previousOfficeStatusName
    ?.toLowerCase()
    ?.includes("dark");

  useEffect(() => {
    setColumnOne({
      OriginalOpenedDate: [
        "Original Opened Date",
        !data.originalOpenedDate ||
        data.originalOpenedDate === "1970-01-01T00:00:00"
          ? null
          : new Date(data.originalOpenedDate).toLocaleDateString(),
      ],
      AcquisitionDate: [
        "Acquisition Date",
        !data.acquisitionDate || data.acquisitionDate === "1970-01-01T00:00:00"
          ? null
          : new Date(data.acquisitionDate).toLocaleDateString(),
      ],
      OpenedDate: [
        "Opened Date",
        !data.officeOpenedDate ||
        data.officeOpenedDate === "1970-01-01T00:00:00"
          ? null
          : new Date(data.officeOpenedDate).toLocaleDateString(),
      ],

      DarkStatusEffective: [
        "Dark Status Effective",
        data.darkReasonEffectiveDate === null
          ? null
          : new Date(data.darkReasonEffectiveDate).toLocaleDateString(),
      ],
      DarkStatusReason: ["Dark Status Reason", data.officeDarkReason],
    });
    setColumnTwo({
      RelocationDate: [
        "Relocation Date",
        data.relocationDate === null
          ? null
          : new Date(data.relocationDate).toLocaleDateString(),
      ],
      ClosedDate: [
        "Closed Date",
        !data.officeClosedDate ||
        data.officeClosedDate === "1970-01-01T00:00:00"
          ? null
          : new Date(data.officeClosedDate).toLocaleDateString(),
      ],
      ClosedStatusReason: ["Closed Status Reason", data.closedReason],
      ExpectedLength: [
        "Expected Length of Closure/Reopen Date",
        data.expectedLengthOfClosureReopenDate,
      ],
      ReOpenedDate: [
        "Re-Opened Date",
        data.reOpenDate === null
          ? null
          : new Date(data.reOpenDate).toLocaleDateString(),
      ],
    });
  }, []);

  return (
    <div className="w-full">
      <div className="grid text-xs px-9 py-2 gap-y-1 md:grid-cols-2">
        <div className="space-y-1">
          {Object.values(columnOne).map((item, i) => {
            return (
              //   item[0] === "Dark Status Effective" ||
              //   item[0] === "Dark Status Reason") &&
              //   !darkStatus ? (
              //   ""
              // ) : (
              <div key={i} className="w-full border-b border-gray-200 py-1">
                <div className="grid grid-cols-2 col-span-2">
                  <div className="expandedLabel fontExpand text-left">
                    <span>{item[0]}:</span>
                  </div>
                  <span className="expandedData fontExpand">
                    {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="space-y-1">
          {Object.values(columnTwo).map((item, i) => {
            return (
              //  item[0] === "ReOpened Date" &&
              //   ((!ReOpen && !prevStatus) || (ReOpen && !prevStatus)) ? (
              //   ""
              // ) : (
              <div key={i} className="w-full border-b border-gray-200 py-1">
                <div className="grid grid-cols-2 col-span-2">
                  <div className="expandedLabel fontExpand text-left">
                    <span>{item[0]}:</span>
                  </div>
                  <span className="expandedData fontExpand">
                    {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OfficeDates;
